import { Link } from 'react-router-dom';
import { useHospitalQuery } from 'services/hospital';
import { getDataByLanguageId } from 'utils/functions';
import ExternalLinkModal from 'components/organisms/external-link-modal';

export default function ContactLinks() {
  const { data, isSuccess } = useHospitalQuery({ hospitalId: 8 });

  if (isSuccess) {
    const { facebookAddress, instagramAddress, twitterAddress, webSite } = getDataByLanguageId(
      data.data.contacts
    );

    return (
      <div className="mb-4 mt-auto flex gap-5 px-3 py-2">
        {facebookAddress && (
          <ExternalLinkModal url={facebookAddress} title="Facebook" className="hover-transition">
            <img
              className="w-6"
              src={new URL('assets/svg/facebook-dot.svg', import.meta.url).href}
              alt="facebook icon"
            />
          </ExternalLinkModal>
        )}

        {instagramAddress && (
          <ExternalLinkModal url={instagramAddress} title="Instagram" className="hover-transition">
            <img
              className="w-6"
              src={new URL('assets/svg/instagram-dot.svg', import.meta.url).href}
              alt="instagram icon"
            />
          </ExternalLinkModal>
        )}

        {twitterAddress && (
          <ExternalLinkModal url={twitterAddress} title="Twitter" className="hover-transition">
            <img
              className="w-6"
              src={new URL('assets/svg/twitter-dot.svg', import.meta.url).href}
              alt="twitter icon"
            />
          </ExternalLinkModal>
        )}

        {webSite && (
          <ExternalLinkModal url={webSite} title="Website" className="hover-transition">
            <img
              className="w-6"
              src={new URL('assets/svg/world-dot.svg', import.meta.url).href}
              alt="website icon"
            />
          </ExternalLinkModal>
        )}
      </div>
    );
  }

  return null;
}
